// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__29iml","emails":"CreateEditClinics_emails__2aDhJ","emailTagLabel":"CreateEditClinics_emailTagLabel__SEcA7"};